import axios from "axios";
import { t } from "@/lib/i18n";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "hf_token";

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((c) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use((r) => r, (err) => {
  const url = err?.config?.url || "";
  if (err?.response?.status === 401 && localStorage.getItem(TOKEN_KEY) && !url.startsWith("/auth/")) {
    localStorage.removeItem(TOKEN_KEY);
    window.location.assign("/login?expired=1");
  }
  return Promise.reject(err);
});

export function errMsg(e) {
  return t(rawErr(e));
}

function rawErr(e) {
  const d = e?.response?.data?.detail;
  if (d == null) return e?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (typeof d.msg === "string") return d.msg;
  return String(d);
}

export const money = (n, cur) => {
  const v = Number(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  return cur ? `${cur} ${v}` : `$${v}`;
};

export const fmtDate = (s) => {
  if (!s) return "—";
  const d = new Date(s);
  return isNaN(d) ? s : d.toLocaleDateString(undefined, { day: "2-digit", month: "short", year: "numeric" });
};

export const fmtTime = (s) => new Date(s).toLocaleString(undefined, { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });

export async function openDocument(docId) {
  const res = await api.get(`/documents/${docId}`, { responseType: "blob" });
  const url = URL.createObjectURL(res.data);
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}
